module.exports = __webpack_public_path__ + "img/created.bbf2b125.png";